import React from 'react';
import { Box } from '@mui/material';
import { SpotPricePeriod } from '../../../../../core/src/shared/enums';

export const ColBoolean = ({
  pricePeriod = SpotPricePeriod['60M'],
  periodIndex,
  value,
  tooltip,
}: {
  pricePeriod?: SpotPricePeriod;
  periodIndex: number;
  value: boolean;
  tooltip?: string;
}) => {
  return (
    <Box
      sx={{
        gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
        py: 0.5,
      }}
      className={`spot-summary-col-${pricePeriod}-${periodIndex}`}
      data-tooltip={tooltip}
    >
      <Box
        sx={{
          width: 'auto',
          height: { xs: 18, sm: 26 },
          bgcolor: value ? 'primary.main' : 'grey.200',
        }}
      />
    </Box>
  );
};
